import { DatiqLogLevels } from './datiq-log.enum';
import { IDatiqLog } from './datiq-log.interface';

export const emptyDatiqLog: IDatiqLog = {
    id: `${Date.now()}`,
    message: '',
    timestamp: new Date(),
    level: DatiqLogLevels.Unknown,
};

export const generateDatiqLogMessage: (
    prefix: string,
    message: string
) => string = (prefix: string, message: string) => `${prefix} - ${message}`;

